import { date, showAlert } from '../../lib/helpers';
import { headers, search } from './attributes';


export default {
  data: () => ({
    isFirstLoad: true,
    rangeDateDialog: false,
    options: {},
    headers,
    filter: {
      created_at: [],
    },
    search,
    selectedRow: '',
    editedIndex: -1,
    filterValue: { created_at: [],  mid: '', },
    filterConfig: [
      { key: 'created_at', type: 'daterange', required: true, props: { label: 'Transaction Date', includeToday: true, limitRangeTo30Days: true } },
      { key: 'mid', type: 'textfield', props: { label: 'MID' } },
    ],
  }),

  computed: {
    allData() {
      return this.$store.state.monitoringMerchant.allData;
    },

    detailData() {
      return this.$store.state.monitoringMerchant.item;
    },

    totalData() {
      return this.$store.state.monitoringMerchant.totalData;
    },

    totalPage() {
      return this.$store.state.monitoringMerchant.totalPage;
    },

    loading() {
      return this.$store.state.monitoringMerchant.loading;
    },

    flashError: {
      get() {
        return this.$store.state.monitoringMerchant.flashError;
      },
      set() {
        this.$store.commit('monitoringMerchant/setFlashErrorMessage', '');
      },
    },
    flashErrorMessage() {
      return this.$store.state.monitoringMerchant.flashErrorMessage;
    },
  },

  watch: {
    options: {
      handler() {
        if (!this.isFirstLoad) {
          this.getData();
        } else {
          this.$store.commit('monitoringMerchant/clearData');
        }
        this.isFirstLoad = false;
      },
      deep: true,
    },
  },

  methods: {
    updateSearch(newSearch) {
      this.search.created_at = newSearch.created_at || [];
      this.search.mid = newSearch.mid || '';
      this.options.page = 1;
      this.getData(); 
    },
    showType(newSearch) {
      this.search.created_at = newSearch.created_at || [];
      this.search.mid = newSearch.mid || '';
      this.options.page = 1;
      this.getData(); 
    },

    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    getData() {
      if (this.search.created_at.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Transaction date is required !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('monitoringMerchant/clearData');
      } else {
        this.$store.commit('monitoringMerchant/setFlashErrorMessage', '');
        const { page, itemsPerPage } = this.options;
        this.$store
          .dispatch('monitoringMerchant/getData', {
            date,
            page,
            itemsPerPage,
            search: this.search,
          })
          .then(() => {
            if (this.totalPage < page) {
              if (this.totalPage === 0) {
                this.options.page = 1;
              } else {
                this.options.page = this.totalPage;
              }
            }
          });
      }
    },

    clearSearch() {
      this.search.mid = '';
      this.search.created_at = [];
      this.filter.created_at = [];
    },

    exportItem() {
      if (this.search.created_at.length < 1) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Data is empty !',
          'mdi-alert',
          'red'
        );
        this.$store.commit('monitoringMerchant/clearData');
      } else {
        const { page, itemsPerPage } = this.options;
        this.$store.dispatch('monitoringMerchant/exportList', {
          date,
          page,
          itemsPerPage,
          sortBy: ['v.id'],
          sortDesc: [true],
          search: this.search,
        });
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};